



















import {Component} from "vue-property-decorator";
import BaseDialog from "@/component/Dialog/base-dialog.vue";
import DialogFooter from "@/component/Dialog/dialog-footer.vue";

@Component({
  components: {
    DialogFooter,
  }
})
export default class CreateDialog extends BaseDialog {
}
